import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintManager_create_manufacturing_order_copiesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { name?: string, template_order_id?: number, pre_requirements?: any, copies_params?: { offset_in_days?: number, total_runs?: number }, schedule?: { date_option?: string, date_interval?: any, time_option?: string, time_interval?: any, time_offset?: number, time_zone?: { country?: string, utc?: string, time_zone?: string } } }): Promise<{ order_ids: number[], reasons: string[] }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/functions/create_manufacturing_order_copies`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

